module.exports = __webpack_public_path__ + "static/media/jm.67f96b2f.svg";